import React from 'react'
import { Link } from 'react-router-dom'

const ForgotPasswordPage: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-center text-3xl font-bold tracking-tight text-gray-900">
          Forgot your password?
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          We'll send you a reset link
        </p>
      </div>

      <form className="space-y-6">
        <div>
          <label htmlFor="email" className="block text-sm font-medium text-gray-700">
            Email address
          </label>
          <div className="mt-1">
            <input
              type="email"
              className="form-input"
              placeholder="Enter your email"
            />
          </div>
        </div>

        <div>
          <button type="submit" className="btn btn-primary w-full btn-lg">
            Send reset link
          </button>
        </div>
      </form>

      <div className="text-center">
        <Link
          to="/auth/login"
          className="font-medium text-primary-600 hover:text-primary-500 transition-colors"
        >
          Back to login
        </Link>
      </div>
    </div>
  )
}

export default ForgotPasswordPage